/* eslint-disable no-use-before-define */
/* eslint-disable jsx-a11y/no-static-element-interactions */
/* eslint-disable no-unused-vars */
import { Dropdown, Menu } from 'antd';
import React, { useEffect, useRef, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useHistory, useLocation } from 'react-router-dom';
import queryString from 'query-string';
import { getProductCategories } from '../../redux/products/productsActions';
import DokanIcons from '../icon/DokanIcons';

// const DokanItemCategoryFilter = () => (
//     <Dropdown
//         overlay={
//             <Menu>
//                 <Menu.Item>
//                     <a target="_blank" href="http://www.alipay.com/" rel="noreferrer">
//                         Men
//                     </a>
//                 </Menu.Item>
//                 <Menu.Item>
//                     <a target="_blank" rel="noreferrer" href="http://www.taobao.com/">
//                         Woman
//                     </a>
//                 </Menu.Item>
//                 <Menu.Item>
//                     <a target="_blank" rel="noreferrer" href="http://www.tmall.com/">
//                         Child
//                     </a>
//                 </Menu.Item>
//             </Menu>
//         }
//         placement="bottomCenter"
//         arrow
//     >
//         <button className="pl-35px focus:outline-none" type="button">
//             <div className="filter-button">
//                 <p className="mr-10px text-secondary">
//                     Select <span className="text-base font-medium">Category</span>
//                 </p>
//                 <DokanIcons icon="#carrotDown" size={2} />
//             </div>
//         </button>
//     </Dropdown>
// );

const DokanItemCategoryFilter = () => {
    const { pathname, search } = useLocation();
    const history = useHistory();
    const dispatch = useDispatch();
    const ref = useRef();
    const [showCategories, setShowCategories] = useState(false);
    const [currentCategories, setCurrentCategories] = useState('');
    const { productCategories } = useSelector((state) => state.products);
    const handleClickOutside = (event) => {
        if (ref.current && !ref.current.contains(event.target)) {
            setShowCategories(false);
        }
    };
    const toggleCategories = (name, id) => {
        setCurrentCategories(name);
        setShowCategories(false);
        const qParam = { category: id };
        const newURL = queryString.stringifyUrl({
            url: pathname + search,
            query: qParam,
        });
        console.log(newURL);
        history.replace(newURL);
    };
    function getTreeData() {
        return productCategories.map((item) => ({
            ...item,
            hasChildren: productCategories.filter((i) => i.parent === item.id).length > 0,
        }));
    }

    const treeData = getTreeData();
    // prepare query parameter search...
    // const queryString = (qParam) => new URLSearchParams(qParam);
    useEffect(() => {
        dispatch(getProductCategories());
        document.addEventListener('click', handleClickOutside, true);
        return () => {
            document.removeEventListener('click', handleClickOutside, true);
        };
    }, [dispatch]);
    return (
        <>
            <div className="relative inline-flex justify-center items-center" ref={ref}>
                <span
                    className="text-gray-dark cursor-pointer px-2"
                    onClick={() => setShowCategories(!showCategories)}
                >
                    {currentCategories ? (
                        <div className="flex justify-start items-center gap-3">
                            <div className="font-bold">{currentCategories}</div>
                            <div>
                                {showCategories ? (
                                    <DokanIcons icon="#up_triangle" size={2} />
                                ) : (
                                    <DokanIcons icon="#down_triangle" size={2} />
                                )}
                            </div>
                        </div>
                    ) : (
                        <div className="flex justify-start items-center gap-3">
                            <div className="font-bold">Select Category</div>
                            <div>
                                {showCategories ? (
                                    <DokanIcons icon="#up_triangle" size={2} />
                                ) : (
                                    <DokanIcons icon="#down_triangle" size={2} />
                                )}
                            </div>
                        </div>
                    )}
                </span>
                {showCategories && (
                    <div className="filter-categories">
                        <div className="filter-categories-arrow" />
                        <div className="px-5 pt-10 pb-4">
                            {productCategories && (
                                <>
                                    <RecursiveList data={treeData} />
                                </>
                            )}
                        </div>
                    </div>
                )}
            </div>
        </>
    );
};
export default DokanItemCategoryFilter;

function RecursiveList({ data, parent = 0, level = 0 }) {
    const items = data.filter((item) => item.parent === parent);
    if (!items.length) return null;

    return (
        <>
            {items.map((item) => (
                <>
                    <div key={item.id}>
                        <RecursiveLabel key={item.id} item={item} level={level}>
                            <RecursiveList
                                key={item.id}
                                data={data}
                                parent={item.id}
                                level={level + 1}
                            />
                        </RecursiveLabel>
                    </div>
                </>
            ))}
        </>
    );
}

function RecursiveLabel({ item, level, children }) {
    const [toggleLabel, setToggleLabel] = useState(false);
    return (
        <>
            <div>
                <div
                    style={{ marginLeft: level * 15 }}
                    className="py-2 hover:text-dokan"
                    onClick={() => setToggleLabel(!toggleLabel)}
                >
                    <div className="flex justify-between items-center">
                        <div>{item.name}</div>
                        {item.hasChildren && (
                            <div>
                                <DokanIcons icon="#arrowDownst" size={2} />
                            </div>
                        )}
                    </div>
                </div>
                {toggleLabel && <div className="">{children}</div>}
            </div>
        </>
    );
}
